// @flow
import React from 'react';
import styled from 'styled-components';
import { font } from 'styles/Constants';
import accounting from 'accounting';
import SummaryPayment from 'components/shared/SummaryPayment';
import { SummaryItem } from 'components/shared/SummaryPayment';

export const IVA_ON_COMMISSION = 'IVA sobre la comisión (16%)';

const CircleRadio = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ color }) => color || '#278C7E'};
  background-clip: content-box;
  padding: 3px;
  border: 2px solid ${({ color }) => color || '#278C7E'};
  cursor: pointer;
`;

const BoxRadioSelectContainer = styled.div`
  box-shadow: 0px 4px 4px 0px rgb(0 0 0 / 25%);
  border-radius: 4px;
`;
const CircleRadioEmpty = styled(CircleRadio)`
  padding: 8px;
  cursor: pointer;
`;

const BoxRadioSelect = styled.div`
  display: block;
  height: 35px;
  width: 325px;
  border-radius: 2px;
  background-color: #ffffff;
  padding: 8px;
  margin-top: 10px;
  strong {
    font-weight: normal;
    color: #22766a;
  }
`;

const TextRadioSelect = styled.div`
  height: 19px;
  color: #4a4a4a;
  font-family: ${font.openSans};
  font-size: 14px;
  line-height: 19px;
  margin-top: -20px;
  margin-left: 30px;
  cursor: pointer;
`;

type PropsType = {
  selected?: boolean,
  text: string,
  id: string,
  visible: boolean,
  handleClickSelect: string => void,
  handleGenerateTicket?: (string, string) => void,
  handlePaymentBySrPago?: any => void,
  handleClickCreateStub?: any => void,
  handleAdvancePayment: (
    data: any,
    success: () => void,
    error: () => void
  ) => void,
  activePaymentOption: string,
  paymentMethod: Array<any>,
  paymentData: any,
  paymentDetails: any,
  homeAppData: any,
  contractStartAt: string,
  rentId: string,
  rentalMonthId: string,
  cardNumberSaved: string,
  homeApplicationId: string,
  setUserPaymentData: any => void,
  errorPayment: boolean,
  correctPayment: boolean,
  hideButtonOnRequest: boolean,
  showLoading: boolean,
  promoCode?: string,
  errorTicket?: any,
  homeAppAmount?: any,
  isForAdvisor?: boolean,
  color?: string,
  updateAfterSuccessPayment?: () => void,
  paymentDataFlush?: () => void,
  chargeType: string,
  paymentSchema?: string,
  interestFreeMonthsEnabled?: boolean,
  cardZeroFee?: boolean,
  summaryItems: SummaryItem[],
  commission: number,
  prePaymentValue: number,
  prePaymentCurrency: String,
  isRenewalPayment?: boolean,
  remainingAmount?: number
};

export default function BoxRadioSelectComponent(props: PropsType) {
  let tarDebCre =
    props.activePaymentOption === 'tar_deb_cre' && props.id === 'tar_deb_cre';
  let depOxxo =
    props.activePaymentOption === 'dep_oxxo' && props.id === 'dep_oxxo';
  let depSpei =
    props.activePaymentOption === 'dep_spei' && props.id === 'dep_spei';

  const { color } = props;

  const getTotal = () => {
    return props.paymentDetails.total_to_homie
      ? props.paymentDetails.total_to_homie
      : +props.prePaymentValue
      ? +props.prePaymentValue
      : props.paymentDetails.total_amount
      ? props.paymentDetails.total_amount
      : props.homeAppAmount
      ? props.homeAppAmount
      : 0;
  };

  const getCommission = (commission: number) => {
    return (getTotal() / 100) * commission;
  };

  const getIVA = (commission: number) => {
    return (getTotal() / 100) * commission * 0.16;
  };
  const getCommissionAndIVA = (commission: number) => {
    return getCommission(commission) + getIVA(commission);
  };

  const getTotalAmount = (commission: number) => {
    return getTotal() + getCommissionAndIVA(commission);
  };

  const commissionItem = () => ({
    id: 'commission_and_iva',
    title: 'Comisión + IVA',
    value: `${accounting.formatMoney(getCommissionAndIVA(props.commission))} ${
      props.paymentDetails.currency
    }`
  });

  const total = () => ({
    id: 'total',
    title: 'Total',
    value: `${accounting.formatMoney(getTotalAmount(props.commission))} ${
      props.paymentDetails.currency
    }`
  });

  const getSummaryItems = () => {
    if (props.isRenewalPayment === true) {
      return props.summaryItems.slice(2);
    } else {
      return props.summaryItems;
    }
  };

  return (
    <BoxRadioSelectContainer>
      <BoxRadioSelect
        onClick={() => props.handleClickSelect(props.id)}
        visible={props.visible}
      >
        {props.selected ? (
          <CircleRadio color={color} />
        ) : (
          <CircleRadioEmpty color={color} />
        )}
        <TextRadioSelect dangerouslySetInnerHTML={{ __html: props.text }} />
      </BoxRadioSelect>
      {tarDebCre === true && (
        <SummaryPayment
          prePaymentValue={
            props.prePaymentValue || props.remainingAmount?.total_amount
          }
          prePaymentCurrency={props.paymentDetails.currency}
          summary={{
            items: [
              ...getSummaryItems(),
              {
                ...commissionItem(),
                info: [
                  `Comisión de pago con tarjeta (${props.commission}%)`,
                  IVA_ON_COMMISSION
                ]
              }
            ],
            total: total()
          }}
          currency={props.paymentDetails.currency}
        />
      )}
      {depOxxo === true && (
        <SummaryPayment
          prePaymentValue={
            props.prePaymentValue || props.remainingAmount?.total_amount
          }
          prePaymentCurrency={props.paymentDetails.currency}
          summary={{
            items: [
              ...getSummaryItems(),
              {
                ...commissionItem(),
                info: [
                  `Comisión de pago en efectivo (${props.commission}%)`,
                  IVA_ON_COMMISSION
                ]
              }
            ],
            total: total()
          }}
          currency={props.paymentDetails.currency}
        />
      )}
      {depSpei === true && (
        <SummaryPayment
          prePaymentValue={
            props.prePaymentValue || props.remainingAmount?.total_amount
          }
          prePaymentCurrency={props.paymentDetails.currency}
          summary={{
            items: [
              ...getSummaryItems(),
              {
                ...commissionItem(),
                info: [
                  `Comisión de pago por SPEI (${props.commission}%)`,
                  IVA_ON_COMMISSION
                ]
              }
            ],
            total: total()
          }}
          currency={props.paymentDetails.currency}
        />
      )}
    </BoxRadioSelectContainer>
  );
}
